import {Pipe, PipeTransform} from '@angular/core';
import {TSGesuchsperiode} from '../../../models/entity/TSGesuchsperiode';

/**
 * returns next gesuchsperiode as string representation
 * e.g. for periode 2019/20 it returns '2020/21'
 */
@Pipe({
    name: 'nextPeriodeStr',
    standalone: false
})
export class NextPeriodeStrPipe implements PipeTransform {
    public transform(periode: TSGesuchsperiode): string {
        if (!periode || !periode.gueltigkeit) {
            return '';
        }
        const firstYear = periode.gueltigkeit.gueltigAb.year() + 1;
        const secondYear = firstYear + 1;
        return `${firstYear.toString()}/${secondYear.toString().substr(2)}`;
    }
}
